import PropTypes from "prop-types";

// Material Dashboard 2 PRO React components
import MDBox from "../../../../../components/MDBox";
import MDTypography from "../../../../../components/MDTypography";
import { PUBLIC_URL } from "../../../../../utils/axiosConfig";

function AuthorInfo({ author }) {
  if (!author || !author.user) return null;

  return (
    <MDBox>
      <MDBox mb={1}>
        {author.user.avatar && (
          <MDBox
            component="img"
            src={`${PUBLIC_URL}/${author.user.avatar}`}
            alt="Imagen"
            width="100%"
            maxWidth="250px"
            height="auto"
          />
        )}
      </MDBox>
      <MDTypography variant="h3" fontWeight="bold">
        {author.name + " " + author.last_name}
      </MDTypography>
      <MDBox mt={3} mb={1} ml={0.5}>
        <MDTypography variant="button" fontWeight="regular" color="text">
          Descripción
        </MDTypography>
      </MDBox>
      <MDBox component="ul" m={0} pl={4} mb={2}>
        <MDBox component="li" color="text" fontSize="1.25rem" lineHeight={1}>
          <MDTypography variant="body2" color="text" fontWeight="regular" verticalAlign="middle">
            {author.bio}
          </MDTypography>
        </MDBox>
        <MDBox component="li" color="text" fontSize="1.25rem" lineHeight={1}>
          <MDTypography variant="body2" color="text" fontWeight="regular" verticalAlign="middle">
            Email: {author.email}
          </MDTypography>
        </MDBox>
        <MDBox component="li" color="text" fontSize="1.25rem" lineHeight={1}>
          <MDTypography variant="body2" color="text" fontWeight="regular" verticalAlign="middle">
            Redes sociales: {author.social_media && typeof author.social_media === "object"
              ? Object.entries(author.social_media)
                .map(([key, value]) => `${key}: ${value}`)
                .join(", ")
              : author.social_media || "Ninguna"}
          </MDTypography>
        </MDBox>
        <MDBox component="li" color="text" fontSize="1.25rem" lineHeight={1}>
          <MDTypography variant="body2" color="text" fontWeight="regular" verticalAlign="middle">
            Estado: {author.user.status}
          </MDTypography>
        </MDBox>
      </MDBox>
    </MDBox>
  );
}

AuthorInfo.propTypes = {
  author: PropTypes.object.isRequired,
};

export default AuthorInfo;
